<template>
  <div class="Verify">
    <el-scrollbar :style="scrollbarStyle" wrap-class="scrollbar-wrapper">
      <mu-paper v-show="WaitList.length > 0" :z-depth="1">
        <mu-list toggle-nested>
          <mu-list-item v-for="(item, index) in getWaitList" :key="index" :ripple="false" :open="openIndx === index" button nested @toggle-nested="open = arguments[0] ? index : 0">
            <mu-list-item-action>
              <mu-icon value="send"/>
            </mu-list-item-action>
            <mu-list-item-title>{{ GetDate(item.BookDate) }}</mu-list-item-title>
            <mu-list-item-action>
              <mu-icon value="keyboard_arrow_down" class="toggle-icon" size="24" />
            </mu-list-item-action>
            <mu-list-item v-for="(bitem, bindex) in item.BookList" slot="nested" :ripple="false" :key="bindex" button @click="VerifyInfo(bitem, GetDate(item.BookDate))">
              <mu-list-item-title>
                {{ bitem.StartTime }}-{{ bitem.EndTime }}
              </mu-list-item-title>
              <mu-list-item-action>
                <mu-icon value="info"/>
              </mu-list-item-action>
            </mu-list-item>
          </mu-list-item>
        </mu-list>
      </mu-paper>

      <div v-show="WaitList.length <= 0" class="NoMoreInfo">
        暂无预约信息
      </div>
    </el-scrollbar>

    <mu-container>
      <mu-dialog :open.sync="ShowDet" title="预约信息审核" width="360">
        <div>预约时间：{{ BookTime }}</div>
        <div>经办人：{{ SelBookItem.UserName }}</div>
        <div>联系电话：{{ SelBookItem.Mobile }}</div>
        <div>申请单位：{{ SelBookItem.CompName }}</div>
        <div>来访人员：{{ SelBookItem.UserWithName }}</div>
        <div>来访人数：{{ SelBookItem.UserWithNum }}人</div>
        <div>陪同人员：{{ SelBookItem.VistUserName }}</div>
        <div>陪同人数：{{ SelBookItem.VistNum }}人</div>
        <mu-button slot="actions" flat color="primary" @click="Verify(1)">通过</mu-button>
        <mu-button slot="actions" flat color="primary" @click="Verify(2)">拒绝</mu-button>
        <mu-button slot="actions" flat color="primary" @click="ShowDet = !ShowDet">取消</mu-button>
      </mu-dialog>
    </mu-container>

    <mu-container>
      <mu-dialog :open.sync="ShowMark" title="拒绝原因" width="360">
        <mu-text-field v-model="VerifyMark" :rows-max="6" placeholder="拒绝原因" multi-line/>
        <mu-button slot="actions" flat color="primary" @click="VerifyRef">确定</mu-button>
        <mu-button slot="actions" flat color="primary" @click="ShowMark = !ShowMark">取消</mu-button>
      </mu-dialog>
    </mu-container>
  </div>
</template>

<script>
import { GetWaitList, Verify } from '@/api/all'
import Toast from 'muse-ui-toast'
export default {
  name: 'Verify',
  data() {
    return {
      scrollbarStyle: {
        height: (window.innerHeight - 186) + 'px',
        width: '100%'
      },
      openIndx: 0,
      WaitList: [],
      SelBookItem: {},
      ShowDet: false,
      BookTime: '',
      ShowMark: false,
      VerifyMark: ''
    }
  },
  computed: {
    getWaitList: function() {
      return this.WaitList
    }
  },
  methods: {
    GetWaitVerifyList: function() {
      // this.$emit('WaitVerifyNum', 1, 0)
      GetWaitList().then(res => {
        console.log(res)
        this.WaitList = res.data
        var WaitNum = 0
        this.WaitList.forEach(item => {
          WaitNum += item.BookList.length
        })
        this.$emit('WaitVerifyNum', 1, WaitNum)
      })
    },
    GetDate: function(BookDate) {
      var BookDateArr = BookDate.split(' ')
      return BookDateArr[0]
    },
    VerifyInfo: function(BookItem, BookTime) {
      console.log(BookItem)
      this.SelBookItem = {}
      this.BookTime = ''
      this.SelBookItem = BookItem
      this.BookTime = BookTime + (BookItem.TimeType === 1 ? ' 上午 ' : ' 下午 ') + BookItem.StartTime + '-' + BookItem.EndTime
      this.ShowDet = true
    },
    Verify: function(type) {
      console.log(type)
      if (type === 1) {
        Verify(this.SelBookItem.Id, 1, '').then(res => {
          console.log(res)
          if (res.error !== 0) {
            Toast.error(res.msg)
          } else {
            Toast.success(res.msg)
          }
          this.ShowDet = false
          this.GetWaitVerifyList()
        })
      } else if (type === 2) {
        this.ShowDet = false
        this.ShowMark = true
      } else {
        console.log(1111)
      }
    },
    VerifyRef: function() {
      Verify(this.SelBookItem.Id, 2, this.VerifyMark).then(res => {
        console.log(res)
        if (res.error !== 0) {
          Toast.error(res.msg)
        } else {
          Toast.success(res.msg)
        }
        this.ShowDet = false
        this.ShowMark = false
        this.GetWaitVerifyList()
      })
    }
  }
}
</script>

<style scoped>
.NoMoreInfo{
  text-align: center;
  width: 100%;
  margin-top: 50px;
  font-size: 25px;
  color: rgb(120, 120, 120)
}
</style>



// WEBPACK FOOTER //
// src/view/Login/components/Verify.vue